import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../../proptypes/jobProptypes';

// Context
import ApproachContext from '../../../../../context/ApproachContext';

// Icons
import { Globe } from '../../../../icons';

// Styles
import styles from '../jobBulletpoints.module.scss';

const JobRemoteOption = ({ job, textColor }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  const calculateRemoteLine = () => {
    let remoteLine = null;
    // if (job.fully_remote) {
    //   remoteLine = t(
    //     `description_page.main_section.remote_possible.${approach}`,
    //   );
    // } else
    if (job.extra_info?.homeoffice && job.extra_info?.home_days) {
      remoteLine = t(
        `description_page.main_section.${
          job.extra_info?.home_days === 1
            ? 'home_office_one_day'
            : 'home_office_multiple_days'
        }.${approach}`,
        {
          number: job.extra_info?.home_days,
        },
      );
    }

    return remoteLine;
  };

  const remoteLine = calculateRemoteLine();

  if (
    // !job.fully_remote &&
    !job.extra_info?.homeoffice ||
    !remoteLine
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <span className={styles.content}>
        <span className={styles.iconWrapper}>
          <Globe fill={textColor} className={styles.icon} />
        </span>

        <span className={styles.text}>{remoteLine}</span>
      </span>
    </div>
  );
};

JobRemoteOption.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  textColor: PropTypes.string.isRequired,
};

export default JobRemoteOption;
